module.exports = __webpack_public_path__ + "static/media/00653-TURNOS NOT  SÁBADOS 2025 - 2026 JURIDICA.6a5e74b4.pdf";